import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { API } from './constants';

export const formatPostDate = (value) => value ? new Date(value).toLocaleDateString('es-VE', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

export const CATEGORY_COLORS = {
  Visas: 'bg-indigo-100 text-indigo-700',
  Salud: 'bg-rose-100 text-rose-700',
  Consejos: 'bg-amber-100 text-amber-700',
  Destinos: 'bg-emerald-100 text-emerald-700',
};

export const CategoryBadge = ({ categoria }) => categoria ? (
  <span data-testid="post-category-badge" className={`inline-block text-xs font-semibold rounded-full px-2.5 py-1 ${CATEGORY_COLORS[categoria] || 'bg-slate-100 text-slate-600'}`}>{categoria}</span>
) : null;

export const PostCard = ({ post, index }) => (
  <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${index}`} className="group bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300 flex flex-col">
    {post.imagen_url ? (
      <img src={post.imagen_url} alt={post.titulo} className="h-48 w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
    ) : (
      <div className="h-48 bg-gradient-to-br from-blue-600 to-red-500"></div>
    )}
    <div className="p-6 flex flex-col flex-1">
      <div className="flex items-center gap-2 mb-2"><CategoryBadge categoria={post.categoria} /><p className="text-xs text-slate-500">{formatPostDate(post.fecha_publicacion)}</p></div>
      <h4 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors">{post.titulo}</h4>
      <p className="text-slate-600 text-sm flex-1">{post.resumen}</p>
      <span className="mt-4 inline-flex items-center text-blue-600 font-semibold text-sm">Leer artículo <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" /></span>
    </div>
  </Link>
);

export const BlogSection = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { axios.get(`${API}/blog`).then(({ data }) => setPosts(data.data.slice(0, 3))).catch(() => {}); }, []);
  if (posts.length === 0) return null;
  return (
    <section className="py-20 bg-white" data-testid="blog-section">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-red-500 bg-red-50 rounded-full px-4 py-1.5 mb-4"><BookOpen className="h-4 w-4" /> Blog</span>
            <h3 className="text-4xl font-bold text-slate-900">Consejos para viajar protegido</h3>
          </div>
          <Link to="/blog" data-testid="blog-see-all" className="inline-flex items-center text-blue-600 font-semibold hover:underline">Ver todos los artículos <ArrowRight className="h-4 w-4 ml-1" /></Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => <PostCard key={p.id} post={p} index={i} />)}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
